import suggestedUserStructure from "../Constants/SuggesteduserStructure";

/**
 * Fetches and formats suggested users data from a mock JSON file.
 * @returns {Promise<Object|null>} - Returns formatted suggestedUserStructure or null if an error occurs
 */
export async function fetchSuggestedUsers() {
  try {
    // 🔹 Fetch JSON data (from your mock API in public folder)
    const response = await fetch("/api/mock/AccountPage/UserAccountSuggestedUserMockData.json");

    if (!response.ok) {
      throw new Error(`❌ Failed to load suggested users: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();

    console.log("data: ", data);

    // 🔹 Format and validate the data
    const formattedData = {
      ...suggestedUserStructure,
      userId: data.userId || "",
      userUUID: data.userUUID || "",
      name: {
        firstName: data.name?.firstName || "",
        lastName: data.name?.lastName || ""
      },
      imageUrl: data.imageUrl || "",
      gender: data.gender || "",
      ethenic: data.ethenic || "",
      email: data.email || "",
      password: data.password || "",
      mobileNumber: data.mobileNumber || "",
      devices: data.devices || [],
      dateOfBirth: data.dateOfBirth || "",
      address: {
        street: data.address?.street || "",
        city: data.address?.city || "",
        state: data.address?.state || "",
        zipCode: data.address?.zipCode || "",
        country: data.address?.country || ""
      },
      users: Array.isArray(data.users)
        ? data.users.map((user) => ({
            userId: user.userId || "",
            userName: user.userName || "",
            useruuid: user.useruuid || "",
            location: user.location || "",
            profileImage: user.profileImage || "/assets/User/default-profile.jpg",
            joinedon: user.joinedon || "",
            activelevel: user.activelevel || "",
          }))
        : [],
    };

    return formattedData;
  } catch (error) {
    console.error("🚨 Error fetching suggested users:", error);
    return null;
  }
}
